import { Pipe, PipeTransform } from '@angular/core';
import { TipoCombustivelResponse } from '../grade-combustiveis/tabela-combustiveis';




@Pipe({
  name: 'codCombustivelParaNome'
})
export class CsvPostoPipe implements PipeTransform {
  transform(numeroCombustivel: number, combustiveis: TipoCombustivelResponse[]): string {
    const comb = combustiveis.find((c: TipoCombustivelResponse) => c.codigoCombustivel === numeroCombustivel);
    return comb ? comb.combustivel : 'Combustível não encontrado';
  }
}



@Pipe({
  name: 'codCombustivelParaCodigo'
})
export class CsvPostoCodigoPipe implements PipeTransform {
  transform(numeroCombustivel: number, combustiveis: TipoCombustivelResponse[]): string {
    const comb = combustiveis.find((c: TipoCombustivelResponse) => c.codigoCombustivel === numeroCombustivel);
    return comb ? comb.descricaoCombustivel : 'Combustível não encontrado';
  }
}



@Pipe({
  name: 'cnpjValido'
})
export class CnpjValidoPipe implements PipeTransform {
  transform(cnpj: string): boolean {
    if (!cnpj) {
      return false;
    }
  // validar formato 51.483.956/0001
  if (!cnpj.match(/^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/)) {
    return false;
  }
    cnpj = cnpj.replace(/[^\d]+/g, '');
    if (cnpj === '') {
      return false;
    }
    if (cnpj.length !== 14) {
      return false;
    }
    // Elimina CNPJs invalidos conhecidos
    if (
      cnpj === '00000000000000' ||
      cnpj === '11111111111111' ||
      cnpj === '22222222222222' ||
      cnpj === '33333333333333' ||
      cnpj === '44444444444444' ||
      cnpj === '55555555555555' ||
      cnpj === '66666666666666' ||
      cnpj === '77777777777777' ||
      cnpj === '88888888888888' ||
      cnpj === '99999999999999'
    ) {
      return false;
    }
    // Valida DVs
    let tamanho = cnpj.length - 2;
    let numeros = cnpj.substring(0, tamanho);
    const digitos = cnpj.substring(tamanho);
    let soma = 0;
    let pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += +numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }
    let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== +digitos.charAt(0)) {
      return false;
    }
    tamanho += 1;
    numeros = cnpj.substring(0, tamanho);
    soma = 0;
    pos = tamanho - 7;
    for (let i = tamanho; i >= 1; i--) {
      soma += +numeros.charAt(tamanho - i) * pos--;
      if (pos < 2) {
        pos = 9;
      }
    }
    resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
    if (resultado !== +digitos.charAt(1)) {
      return false;
    }
    return true;
  }
}



@Pipe({ name: 'cnpj' })
export class CnpjPipe implements PipeTransform {
  transform(value: string): string {
  if (!value) return value;
  // Remove caracteres não numéricos
  value = value.replace(/\D/g, '');
  // Formata o CNPJ
  return value.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5'); }
}
